import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import Select from "react-select";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import CustomButton from "../../../ui/custom-button";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import {
  AddProfessorApi,
  CourseListApi,
  ProfessorDetailApi,
  SemesterListApiByCourse,
  SubjectListApiBySemester,
  UpdateProfessorApi,
} from "../../../api/api";
import { PulseLoader } from "react-spinners";

function AddProfessor() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState([]);
  const [semester, setSemester] = useState([]);
  //console.log("course", course);
  const [subjects, setSubjects] = useState([]);
  //console.log("subjects", subjects);
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});

  const fetchData = async () => {
    try {
      const detail = await ProfessorDetailApi(data);
      if (detail?.data?.status === true) {
        const prof = detail?.data?.data;
        setInputData({
          professor_name: prof.professor_name || "",
          subject_blocks: [],
        });

        // Group by course_id + semester_id
        const groupMap = {};
        prof.subjects.forEach((item) => {
          const key = `${item.course_id}_${item.semester_id}`;
          if (!groupMap[key]) {
            groupMap[key] = {
              course: item.course_id,
              semester: item.semester_id,
              subjects: [],
            };
          }
          groupMap[key].subjects.push(item.subject_id);
        });

        const blocks = Object.values(groupMap);
        setInputData({
          professor_name: prof.professor_name || "",
          subject_blocks: blocks,
        });

        // Preload semester & subject list for the first block
        if (blocks.length > 0) {
          const first = blocks[0];
          const semRes = await SemesterListApiByCourse(first.course);
          if (semRes?.data?.status) {
            setSemester(semRes.data.semesters);
          }

          const subjRes = await SubjectListApiBySemester(first.semester);
          if (subjRes?.data?.status) {
            setSubjects(subjRes.data.subjects);
          }
        }
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    if (data) {
      fetchData();
    }
  }, []);

  const subjectOptions = subjects.map((subj) => ({
    value: subj._id,
    label: subj.subject_name,
  }));
  const [inputData, setInputData] = useState({
    professor_name: "",
    subject_blocks: [
      {
        course: "",
        subjects: [],
      },
    ],
  });

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubjectBlockChange = async (index, field, value) => {
    const updatedBlocks = [...inputData.subject_blocks];
    updatedBlocks[index][field] = value;
    try {
      const data = await SemesterListApiByCourse(value);
      //console.log("datasemester", data);
      if (data?.data?.status === true) {
        setSemester(data?.data?.semesters);
      }
    } catch (error) {
      //console.log("error", error);
    }
    setInputData((prev) => ({
      ...prev,
      subject_blocks: updatedBlocks,
    }));
  };

  const handleSemesterBlockChange = async (index, field, value) => {
    const updatedBlocks = [...inputData.subject_blocks];
    updatedBlocks[index][field] = value;
    try {
      const data = await SubjectListApiBySemester(value);
      //console.log("datasubject", data);
      if (data?.data?.status === true) {
        setSubjects(data?.data?.subjects);
      }
    } catch (error) {
      //console.log("error", error);
    }
    setInputData((prev) => ({
      ...prev,
      subject_blocks: updatedBlocks,
    }));
  };

  const addSubjectBlock = () => {
    setInputData((prev) => ({
      ...prev,
      subject_blocks: [...prev.subject_blocks, { course: "", subjects: [] }],
    }));
  };

  const removeSubjectBlock = (index) => {
    const updatedBlocks = [...inputData.subject_blocks];
    updatedBlocks.splice(index, 1);
    setInputData((prev) => ({
      ...prev,
      subject_blocks: updatedBlocks,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      professor_name: inputData.professor_name,
      subject_data: inputData.subject_blocks.flatMap((block) =>
        block.subjects.map((subjectId) => ({
          course_id: block.course,
          semester_id: block.semester,
          subject_id: subjectId,
        }))
      ),
    };

    //console.log("Payload:", payload);
    try {
      if (data) {
        const detail = await UpdateProfessorApi(payload, data);
        if (detail) {
          setLoading(false);
          handleClose();
        }
      } else {
        const data = await AddProfessorApi(payload);
        if (data) {
          setLoading(false);
          handleClose();
        }
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const fetchCourse = async () => {
    try {
      const data = await CourseListApi();
      //console.log("data", data);
      if (data?.data?.status === true) {
        setCourse(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchCourse();
  }, []);

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h5 className="m-0">Add Professors</h5>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline color="#fff" size={20} />
        </button>
      </div>

      <div className="p-4 formBox formCstHeight">
        <Customform onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <CustomInput
              name="professor_name"
              placeholder="Enter Name"
              value={inputData.professor_name}
              onChange={handleChange}
            />
          </div>

          <hr className="hr my-4" />

          <div>
            <h5 className="mb-4">Add Subjects</h5>
            {inputData.subject_blocks.map((block, index) => (
              <div className="mb-3 position-relative" key={index}>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <h6 className="fw-semibold mb-0">Subject {index + 1}</h6>
                  {inputData.subject_blocks.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => removeSubjectBlock(index)}
                    >
                      Remove
                    </button>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">Select Course</label>
                  <select
                    className="form-select"
                    value={block.course}
                    onChange={(e) =>
                      handleSubjectBlockChange(index, "course", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {course &&
                      course.map((course) => (
                        <option key={course._id} value={course._id}>
                          {course.course_name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Select Semester</label>
                  <select
                    className="form-select"
                    value={block.semester || ""}
                    onChange={(e) =>
                      handleSemesterBlockChange(
                        index,
                        "semester",
                        e.target.value
                      )
                    }
                  >
                    <option value="">Select</option>
                    {semester &&
                      semester.map((ele) => (
                        <option key={ele._id} value={ele._id}>
                          {ele.semester_name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Select Subject</label>
                  <Select
                    className="form-select selectCst dualArrow"
                    isMulti
                    options={subjectOptions}
                    value={subjectOptions.filter((opt) =>
                      block.subjects.includes(opt.value)
                    )}
                    onChange={(selected) =>
                      handleSubjectBlockChange(
                        index,
                        "subjects",
                        selected.map((s) => s.value)
                      )
                    }
                  />
                </div>
              </div>
            ))}

            <div className="text-end">
              <button
                type="button"
                className="cstLink"
                onClick={addSubjectBlock}
              >
                + Add Another Subject
              </button>
            </div>
          </div>

          <div className="buttonGroup d-flex justify-content-between position-absolute start-0 bottom-0 w-100 p-4 border-top mt-5 bg-white">
            <button
              className="cancelBtn w-100"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>

            {loading ? (
              <button className="nextBtn w-100">
                <PulseLoader color="#fff" />
              </button>
            ) : (
              <button type="submit" className="nextBtn w-100">
                Submit
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddProfessor;
